import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface MensagemUsuario {
    id?: number;
    usuarioId?: number;
    data?: string;
    mensagem: string;
    tipo: 'Urgente' | 'Informativo' | 'Integracao';
}

@Injectable({
    providedIn: 'root'
})
export class MensagemUsuarioService {

    constructor(private http: HttpClient) { }

    // Listar mensagens por usuário e data
    listarMensagens(usuarioId: number, data: string): Observable<MensagemUsuario[]> {
        return this.http.post<MensagemUsuario[]>(`/usuario/listar-mensagens/${usuarioId}/${data}`, {});
    }

    // Salvar mensagem
    salvarMensagem(usuarioId: number, mensagem: string, tipo: string): Observable<MensagemUsuario> {
        const params = new HttpParams()
            .set('usuarioId', usuarioId.toString())
            .set('mensagem', mensagem)
            .set('tipo', tipo);

        return this.http.post<MensagemUsuario>(`/usuario/salvar-mensagem`, null, { params });
    }

    // Salvar mensagem com data específica
    salvarMensagemComData(usuarioId: number, mensagem: string, tipo: string, data: string): Observable<MensagemUsuario> {
        const params = new HttpParams()
            .set('usuarioId', usuarioId.toString())
            .set('mensagem', mensagem)
            .set('tipo', tipo)
            .set('data', data);

        return this.http.post<MensagemUsuario>(`/usuario/salvar-mensagem-com-data`, null, { params });
    }

    excluirMensagem(mensagemId: number): Observable<any> {
        return this.http.delete(`/usuario/excluir-mensagem/${mensagemId}`, {
            responseType: 'text'
        });
    }

    excluirMensagensPorUsuarioData(usuarioId: number, data: string): Observable<any> {
        return this.http.delete(`/usuario/excluir-mensagens-usuario-data/${usuarioId}/${data}`, {
            responseType: 'text'
        });
    }
}